import { defineStore } from 'pinia'
import { ref } from 'vue'
import { requestBuilder } from '@/utils/request-builder.utilities.js'

const { getAllRecords } = requestBuilder()
export const useGenOptStore = defineStore('gen-opt', () => {
    const list = ref([])

    const getList = async (payloads) => {
      try {
        if (list.value && list.value.length > 0) {
          const found = filterList(list.value, payloads)
          if (found.length > 0) {
            return found
          }
        }
        await fetchAllRecords()
        const foundAfterRequest = filterList(list.value, payloads)
        if (!foundAfterRequest || foundAfterRequest.length === 0) {
          return []
        }
        return foundAfterRequest
      } catch (error) {
        console.error('Error fetching data:', error)
        return []
      }
    }

    const fetchAllRecords = async (payloads) => {
      const { data } = await getAllRecords('', 'general_option')
      if (data.statusCode) return;
      list.value = data.data
    }

    const filterList = (list, payloads) => {
      return list?.filter((item) =>
        Object.entries(payloads).every(([key, value]) => item[key] === value),
      )
    }

    const reset =()=>{
      list.value = [];
    }


    return {
      getList,
      fetchAllRecords,
      list,
      reset,
    }
  }, {
  persist: {
    key: 'genOpt',
    paths: ['list'],  
  }
});
